import { dataMediumSquareSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMediumSquareSolid = /*#__PURE__*/createIcon(dataMediumSquareSolid)
export default IconMediumSquareSolid
